import React, { useMemo } from 'react';
import { Collapse, FormGroup, ControlLabel } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import Tooltip from '../../../../../../../../components/Tooltip';
import FormSwitch from '../../../../../../../../components/FormSwitch';
import SelectVirtualized from '../../../../../../../../components/Select/Virtualized';

import * as types from '../../reducer/constants';
import { getOptions, getSelectedValue, getFirstStartCountId } from './helper';

const FieldStartCountParsing = ({ form, dispatchServiceData }) => {
  const { startCounts } = useSelector((state) => state.services);
  const { start_count } = form;

  const selectOptions = useMemo(() => getOptions(startCounts), [startCounts]);
  const selectedValue = useMemo(() => getSelectedValue(startCounts, start_count), [startCounts, start_count]);

  const showCounts = !!start_count;

  const onSubmit = (startCountId) => {
    dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_START_COUNT, value: startCountId })
  };

  const onSwitch = () => {
    if (showCounts) {
      onSubmit(0);
    } else {
      const startCountId = getFirstStartCountId(startCounts);
      if (startCountId) {
        onSubmit(startCountId);
      }
    }
  };

  const onChange = (selectValue) => {
    const { value } = selectValue;
    const valueToNumber = Number(value);
    onSubmit(valueToNumber);
  };

  return (
    <>
      <FormSwitch id="start_count_switch" name="start_count_switch" checked={showCounts} onChange={onSwitch}>
        Start count parsing
        {' '}
        <Tooltip
          placement="top"
          text={(
            <p>
              If you activate this option,
              <br />
              {' '}
              the system will get start count
              <br />
              {' '}
              value for each new order.
              <br />
              {' '}
              It is paid feature.
              <br />
              {' '}
              One query deduct one
              <br />
              {' '}
              parsing credit.
            </p>
          )}
          tooltipClass="tooltip__top"
        >
          <span className="fas fa-info-circle cursor-help" />
        </Tooltip>
      </FormSwitch>
      <Collapse in={showCounts}>
        <div className="mt-10">
          <FormGroup className="form-group__start-count-parsing-count">
            <ControlLabel htmlFor="start_count">Count</ControlLabel>
            <SelectVirtualized
              components={{ IndicatorSeparator: null }}
              onChange={onChange}
              name="start_count"
              noOptionsMessage={() => 'Not found count'}
              hideSelectedOptions={false}
              value={selectedValue}
              options={selectOptions}
              placeholder="Choose count"
            />
          </FormGroup>
        </div>
      </Collapse>
    </>
  );
};

FieldStartCountParsing.propTypes = {
  form: PropTypes.object,
  dispatchServiceData: PropTypes.func,
}

export default FieldStartCountParsing;
